<template>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="header-logo"></div>
        </div>
        <div v-if="isAuthenticated || isLoggedIn">
          <div v-if="loading" class="row">
            <div class="col-12">
              <ProgressSpinner />
            </div>
          </div>
          <div v-else>
            <div style="margin-bottom:50px;">
              <div v-if="!userHasNoFunds" class="row" style="margin-bottom:45px;">
                <div class="col-lg-12 col-md-12">
                  <div style="width:auto;max-width:56rem;margin:auto;">
                    <table class="total-value-table">
                      <thead>
                        <tr>
                          <th colspan="2"></th>
                          <th :colspan="projectedPayouts.length" class="projected-payouts-header">Projected Payouts</th>
                        </tr>
                        <tr>
                          <th>Your Total Value<br> as of {{ new Date().toLocaleDateString() }}</th>
                          <th>Total Paid<br>to Date</th>
                          <th v-for="payout in projectedPayouts" :key="payout.year">{{ payout.year }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="total-value-cell"><strong>{{ formatCurrencyKeepCents(totalPersonalValue) }}</strong></td>
                          <td>{{ formatCurrencyKeepCents(totalPaidToDate) }}</td>
                          <td v-for="payout in projectedPayouts" :key="payout.year">{{ formatCurrencyKeepCents(payout.amount) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="total-value-mobile">
                      <div class="total-value-mobile-hero">
                        <div class="total-value-mobile-label">Your Total Value as of {{ new Date().toLocaleDateString() }}</div>
                        <div class="total-value-mobile-amount">{{ formatCurrencyKeepCents(totalPersonalValue) }}</div>
                      </div>
                      <div class="total-value-mobile-row">
                        <span>Total Paid to Date</span>
                        <span>{{ formatCurrencyKeepCents(totalPaidToDate) }}</span>
                      </div>
                      <div v-if="projectedPayouts.length" class="total-value-mobile-section">Projected Payouts</div>
                      <div v-for="payout in projectedPayouts" :key="payout.year" class="total-value-mobile-row">
                        <span>{{ payout.year }}</span>
                        <span>{{ formatCurrencyKeepCents(payout.amount) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row fund-info hide">
                <div class="col-lg-6 col-md-12" style="margin-bottom:20px;">
                  <div class="row"  style="margin-bottom:10px;">
                    <div class="col-lg-12">
                      <form class="flex flex-column gap-2" style="float:left;">
                        <span style="margin-right:10px;font-weight:bold">As of</span> <Calendar severity="secondary" id="date" v-model="revFundDateSelected" :minDate="minDate" :maxDate="maxDate" view="month" dateFormat="M yy" showIcon />
                        <span style="margin-left:20px;"></span>
                        <Button class="small-button-refresh" severity="secondary" type="button" label="Refresh" @click="onClick" />
                      </form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" >
                      <div v-if="revFundChartLoading">
                        <ProgressSpinner />
                      </div>
                      <div v-else>
                        <RevolutionFund :revolutionFundData="revolutionFund" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12" style="margin-bottom:20px;">
                  <div class="row">
                    <h5>Daily Performance
                        <Button @click="performanceChartClick('gain')" class="small-button" severity="secondary" v-bind:class="{ active: gainActive }" text label="Gain"></Button>  
                        <Button @click="performanceChartClick('totalValue')" class="small-button" severity="secondary" v-bind:class="{ active: totalValueActive }" text label="Total Value"></Button>
                    </h5>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <Button @click="performanceFilterClick('5D')" class="small-button" v-bind:class="{ active: fiveDayActive }" severity="secondary" text label="5D" />
                      <Button @click="performanceFilterClick('1M')" class="small-button" v-bind:class="{ active: oneMonthActive }" severity="secondary" text label="1M" />
                      <Button @click="performanceFilterClick('6M')" class="small-button" v-bind:class="{ active: sixMonthActive }" severity="secondary" text label="6M" />
                      <Button @click="performanceFilterClick('YTD')" class="small-button" v-bind:class="{ active: yearToDateActive }" severity="secondary" text label="YTD" />
                      <Button @click="performanceFilterClick('1Y')" class="small-button" v-bind:class="{ active: oneYearActive }" severity="secondary" text label="1Y" />
                      <Button @click="performanceFilterClick('5Y')" class="small-button" v-bind:class="{ active: fiveYearActive }" severity="secondary" text label="5Y" />
                      <Button @click="performanceFilterClick('Max')" class="small-button" v-bind:class="{ active: maxActive }" severity="secondary" text label="Max" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div v-if="totalValueActive">
                        <Chart type="line" :data="dailyChartData" :options="dailyChartOptions" />
                      </div>
                      <div v-else-if="gainActive">
                        <Chart type="line" :data="dailyChartDataGain" :options="dailyChartOptions" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-12 col-md-12" style="margin-bottom:20px;">
                      <CompanyInvestment :companyFunds="companyFunds" :version="2" />
                    </div>
                  </div>
                  <div v-if="!userHasNoFunds" class="row">
                    <div class="col-lg-12 col-md-12">
                      <FundList :funds="funds" :version="2" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  
                  <div class="row">  
                    <div class="col-lg-12 col-md-12"  style="margin-bottom:31px;">
                      <RevolutionFundChart />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-md-12">
                      <CompanyPerformance :companyPerformance="companyPerformance" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="login-page">
            <div class="container">
              <div class="row mx-auto flex justify-content-center" style="margin-bottom:20px;width:200px;">
                  <Button @click="login" icon="pi pi-ckeck" label="Login with Okta" />
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-4 mx-auto">
                  <div class="card login">
                    <h1>Sign In</h1>
                    <form class="form-group">
                      <Message v-for="msg of messages" :key="msg.id" :severity="msg.severity">{{ msg.content }}</Message>
                      <input v-model="loginInput.username" type="email" class="form-control" placeholder="Email" required />
                      <input v-model="loginInput.password" type="password" class="form-control" placeholder="Password" required />
                      <Button @click="doLogin" label="Submit" :loading="authenticating"></Button>
                      <hr>
                      <p>Don't have an account? <router-link to="/register">Sign up here</router-link>
                      </p>
                      <p><router-link to="/forgotpassword">Forgot your password?</router-link></p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FundList from '../components/FundList.vue'
  import RevolutionFund from '../components/RevolutionFund.vue'
  import CompanyInvestment from '../components/CompanyInvestments.vue'
  import RevolutionFundChart from '../components/RevolutionFundChart.vue'
  import CompanyPerformance from '../components/CompanyPerformance.vue'
  import { getAllFunds, getRevolutionFundData, getCompanyFundData, getDailyInvestmentData, getCompanyPerformanceData } from '@/services/FundService'
  import { authenticateUser } from '@/services/UserService'
  import { mapGetters, mapMutations } from "vuex"
  import { ref } from 'vue'
  
  export default {
    name: 'RevFund2',
    components: {
      FundList,
      RevolutionFund,
      CompanyInvestment,
      RevolutionFundChart,
      CompanyPerformance
    },
    methods: {
      ...mapMutations(["setUser", "setToken", "resetState", "setWorkdayId"]),
      async login () {
        await this.$auth.signInWithRedirect({ originalUri: '/' });
      },
      async handleApiError(err) {
        this.loading = false;
        this.revFundChartLoading = false;
        if (err.message === 'UNAUTHORIZED') {
          if (this.isLoggedIn) {
            this.resetState();
          } else {
            await this.login();
          }
        }
      },
      async getValidToken() {
        let tokenObj = await this.$auth.tokenManager.get('accessToken');
        if (!tokenObj) {
          try {
            tokenObj = await this.$auth.tokenManager.renew('accessToken');
          } catch (e) {
            return null;
          }
        }
        return tokenObj ? tokenObj.accessToken : null;
      },
      performanceChartClick (chartName) {
        switch(chartName)
        {
          case 'totalValue':
            this.totalValueActive = true;
            this.gainActive = false;
            break;
          case 'gain':
            this.totalValueActive = false;
            this.gainActive = true;
            break;
        }
      },
      performanceFilterClick (timeScale) {
  
        let today = new Date();
        let dateFilter = new Date();
  
        switch(timeScale)
        {
          case '5D':
            this.fiveDayActive = true;
            this.oneMonthActive = false;
            this.sixMonthActive = false;
            this.yearToDateActive = false;
            this.oneYearActive = false;
            this.fiveYearActive = false;
            this.maxActive = false;
  
            dateFilter = new Date(today.setDate(today.getDate() - 5));
  
            break;
          case '1M':
            this.fiveDayActive = false;
            this.oneMonthActive = true;
            this.sixMonthActive = false;
            this.yearToDateActive = false;
            this.oneYearActive = false;
            this.fiveYearActive = false;
            this.maxActive = false;
  
            dateFilter = today.setMonth(today.getMonth() - 1);
  
            break;
          case '6M':
            this.fiveDayActive = false;
            this.oneMonthActive = false;
            this.sixMonthActive = true;
            this.yearToDateActive = false;
            this.oneYearActive = false;
            this.fiveYearActive = false;
            this.maxActive = false;
  
            dateFilter = today.setMonth(today.getMonth() - 6);
  
            break;
          case 'YTD':
            this.fiveDayActive = false;
            this.oneMonthActive = false;
            this.sixMonthActive = false;
            this.yearToDateActive = true;
            this.oneYearActive = false;
            this.fiveYearActive = false;
            this.maxActive = false;
  
            dateFilter = new Date(today.getFullYear(), 0, 1);
  
            break;
          case '1Y':
            this.fiveDayActive = false;
            this.oneMonthActive = false;
            this.sixMonthActive = false;
            this.yearToDateActive = false;
            this.oneYearActive = true;
            this.fiveYearActive = false;
            this.maxActive = false;
  
            dateFilter = today.setFullYear(today.getFullYear() - 1);
  
            break;
          case '5Y':
            this.fiveDayActive = false;
            this.oneMonthActive = false;
            this.sixMonthActive = false;
            this.yearToDateActive = false;
            this.oneYearActive = false;
            this.fiveYearActive = true;
            this.maxActive = false;
  
            dateFilter = today.setFullYear(today.getFullYear() - 5);
  
            break;
          case 'Max':
            this.fiveDayActive = false;
            this.oneMonthActive = false;
            this.sixMonthActive = false;
            this.yearToDateActive = false;
            this.oneYearActive = false;
            this.fiveYearActive = false;
            this.maxActive = true;
  
            dateFilter = today.setFullYear(today.getFullYear() - 100);
  
            break;
          
        }

        this.dailyChartData = this.setDailyChartData(dateFilter);
        this.dailyChartDataGain = this.setDailyChartDataGain(dateFilter);
  
      },
      getFunds(authToken, workDayId) {
        getAllFunds(authToken, workDayId, this.dateSelectedString.replace(/\//g,'-'), "/newfunds").then(res => {
          for(let i = 0; i < res.length; i++)
          {
            for(let j = 0; j < this.companyFunds.length; j++)
            {
  
              if(res[i].fundName == this.companyFunds[j].fund)
              {
                res[i].investmentAmount = this.companyFunds[j].investmentAmount;
                res[i].currentValue = this.companyFunds[j].currentValue;
                res[i].equity = this.companyFunds[j].equity;
                res[i].totalShares = this.companyFunds[j].profitShares;
                res[i].vestedValue = this.companyFunds[j].vestedValue * res[i].numberOfShares;
                res[i].unvestedValue = this.companyFunds[j].unvestedValue * res[i].numberOfShares;
                res[i].paidOut = this.companyFunds[j].paidOut * res[i].numberOfShares;

                res[i].leftToPay = this.companyFunds[j].leftToPay * res[i].numberOfShares;
                res[i].vestingDate = this.companyFunds[j].vestingDate;
                this.totalPersonalValue += res[i].leftToPay

                this.funds.push(res[i]);
              }
            }
          }
          this.numberOfFunds = this.funds.length
          if(this.numberOfFunds > 0)
          {
            this.userHasNoFunds = false;
          }
          this.loading = false;
        }).catch(this.handleApiError);
      },
      getRevolutionFund(authToken, refresh) {
        getRevolutionFundData(authToken, this.revFundDateSelectedString.replace(/\//g,'-'), '/newfunds').then(res => {
          this.revolutionFund = res;
          if(refresh==true) this.revFundChartLoading = false;
        }).catch(this.handleApiError);
      },
      getDailyInvestments(authToken) {
        getDailyInvestmentData(authToken, this.dateSelectedString.replace(/\//g,'-'), '/newfunds').then(res => {
          this.dailyInvestmentData = res;
  
          for(let i = 0; i < this.dailyInvestmentData.length; i++)
          {
  
            var date = new Date(Date.parse(this.dailyInvestmentData[i].rowDate));
  
            if(this.isLastDay(date) || i == this.dailyInvestmentData.length -1)
            {
              this.costAndFMVLabels.push(date.toLocaleDateString('en-us', {month: 'short', year: 'numeric'}));
              this.costData.push(this.dailyInvestmentData[i].revolutionFundCost);
              this.fmvData.push(this.dailyInvestmentData[i].revolutionFundValue);
            }
          }
          this.performanceFilterClick('Max');
        }).catch(this.handleApiError);
      },
      formatCurrencyKeepCents(value) {
        return (value || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      },
      parseVestingYears(vestingDate) {
        if (!vestingDate) return [];
        return vestingDate.split('&')
          .map(datePart => new Date(datePart.trim()))
          .filter(date => !isNaN(date.getTime()))
          .map(date => date.getFullYear());
      },
      isLastDay(dt) {
        var test = new Date(dt.getTime()),
        month = test.getMonth();
  
        test.setDate(test.getDate() + 1);
        return test.getMonth() !== month;
      },
      getCompanyFunds(authToken) {
        getCompanyFundData(authToken, this.dateSelectedString.replace(/\//g,'-'), '/newfunds').then(res => {
          this.companyFunds = res;
        }).catch(this.handleApiError);
      },
      getCompanyPerformance(authToken) {
        getCompanyPerformanceData(authToken, '/newfunds').then(res => {
          this.companyPerformance = res;
        }).catch(this.handleApiError);
      },
      async onClick() {
        this.revFundChartLoading = true;
  
        let date = new Date(this.dateSelected);
        this.dateSelectedString = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + date.getFullYear()
  
        let d = new Date(this.revFundDateSelected);
        this.revFundDateSelectedString = ((d.getMonth() > 8) ? (d.getMonth() + 1) : ('0' + (d.getMonth() + 1))) + '/' + d.getFullYear()
  
  
        let authToken = await this.getValidToken();
        if (!authToken && this.isLoggedIn) {
          authToken = this.$store.state.token;
        }
        if (!authToken) {
          await this.login();
          return;
        }

        this.getRevolutionFund(authToken, true);
  
      },
      setChartData() {
        const documentStyle = getComputedStyle(document.documentElement);
  
        const test = (ctx) => {
  
          var dataIndex = ctx.p0DataIndex;
          var segmentEndAmount = ctx.p1.raw;
          if(segmentEndAmount >= this.costData[dataIndex])
          {
            return documentStyle.getPropertyValue('--green-500');
          }
          else
          {
            return documentStyle.getPropertyValue('--red-500');
          }
          
        }
  
        return {
            labels: this.costAndFMVLabels,
            datasets: [
                {
                    label: 'Cost',
                    data: this.costData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--blue-500'),
                    tension: 0
                },
                {
                    label: 'Total Value',
                    data: this.fmvData,
                    fill: false,
                    borderColor: documentStyle.getPropertyValue('--green-500'),
                    segment: {
                      borderColor: ctx => test(ctx),
                    },
                    tension: 0
                }
            ]
        };
      },
      setDailyChartData(dateFilter) {
        this.dailyLabels = [];
        this.dailyValue = [];
  
        const documentStyle = getComputedStyle(document.documentElement);
  
        var newDailyInvestmentData = this.dailyInvestmentData;
  
        for(let i = 0; i < newDailyInvestmentData.length; i++)
        {
          var date = new Date(Date.parse(newDailyInvestmentData[i].rowDate));
  
          if(date > dateFilter){
            this.dailyLabels.push(date.toLocaleDateString('en-us', {year: 'numeric', day: '2-digit', month: 'short'}));
            this.dailyValue.push(newDailyInvestmentData[i].revolutionFundValue);
          }
          
        }
  
        return {
            labels: this.dailyLabels,
            datasets: [
                {
                    label: 'Revolution Fund Value',
                    data: this.dailyValue,
                    fill:true,
                    borderColor: documentStyle.getPropertyValue('--orange-500'),
                    backgroundColor: 'rgba(255,167,38,0.2)',
                    tension: 0,
                }
            ]
        };
      },
      setDailyChartDataGain(dateFilter) {
        this.dailyGain = [];
  
        var newDailyInvestmentData = this.dailyInvestmentData;
  
        for(let i = 0; i < newDailyInvestmentData.length; i++)
        {
          var date = new Date(Date.parse(newDailyInvestmentData[i].rowDate));
  
          if(date > dateFilter){
            this.dailyGain.push(newDailyInvestmentData[i].gain);
          }
          
        }
  
        return {
            labels: this.dailyLabels,
            datasets: [
                {
                  label: 'Gain',
                  data: this.dailyGain,
                  fill: {
                      target: 'origin',
                      above: 'rgba(95,175,101,0.8',
                      below: 'rgba(208,92,93,0.8)'
                    },
                  borderColor: 'rgba(145, 147, 152, 1)',
                  tension: 0,
                }
            ]
        };
      },
      setDailyChartOptions() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = '#000000';
        const textColorSecondary = '#000000';
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
  
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              tooltip: {
              callbacks: {
                  label: function(context) {
                    let label = context.dataset.label || '';
  
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += '$' + context.parsed.y.toLocaleString();
              }
              return label;
                  }
                }
              },
                legend: {
                    labels: {
                        color: textColor,
                        font: {
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                          size: 14
                        }
                    }
                },
                title: {
                  display: false,
                  text: 'Daily Performance',
                  font: {
                          size: 18,
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                          color: '#2c3e50 !important'
                        }
                },
            },
            scales: {
                x: {
                    // Space ticks back from the last data point so the most recent date is always labeled
                    afterBuildTicks: function(axis) {
                      const lastIndex = axis.ticks.length - 1;
                      const maxTicks = Math.max(2, Math.floor(axis.width / 40));
                      const step = Math.ceil(axis.ticks.length / maxTicks);
                      axis.ticks = axis.ticks.filter((tick, index) => (lastIndex - index) % step === 0);
                    },
                    ticks: {
                      autoSkip: false,
                      color: textColorSecondary,
                      font: {
                        size: 12,
                        family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
                      }
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                          size: 14,
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
                        },
                      callback: function(value) {
                        return '$' + value.toLocaleString();
                      }
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };
      },
      setChartOptions() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = '#000000';
        const textColorSecondary = '#000000';
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
  
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              tooltip: {
              callbacks: {
                  label: function(context) {
                    let label = context.dataset.label || '';
  
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += '$' + context.parsed.y.toLocaleString();
              }
              return label;
                  }
                }
              },
                legend: {
                    labels: {
                        color: textColor,
                        font: {
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                          size: 14
                        }
                    }
                },
                title: {
                  display: false,
                  text: 'Cost and Total Value',
                  font: {
                          size: 18,
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                          color: '#2c3e50 !important'
                        }
                },
            },
            scales: {
                x: {
                    ticks: {
                      maxRotation: 45,
                      minRotation: 45,
                        color: textColorSecondary,
                        font: {
                          size: 14,
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
                        }
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                          size: 14,
                          family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
                        },
                      callback: function(value) {
                        return '$' + value.toLocaleString();
                      }
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };
      },
      async doLogin () {
  
        if(this.loginInput.username == '' || this.loginInput.password == '') {
          this.messages = [
            { severity: 'error', content: 'Email and Password are required.', id: this.messagesCount++ }
          ];
          return;
        }
  
        if(!this.validateEmail()) {
          this.messages = [
            { severity: 'error', content: 'Please enter a valid email address.', id: this.messagesCount++ }
          ];
          return;
        }
  
        this.authenticating = true;
        var authorized = await authenticateUser(this.loginInput.username, this.loginInput.password);
  
        if(authorized){
  
          this.authState.accessToken = authorized.token;
          this.authState.idToken = "";
          this.authState.isAuthenticated = true;
          this.isCustomAuthorized = true;
  
          this.setUser(this.loginInput.username);
          this.setToken(authorized.token);
          this.setWorkdayId(authorized.workdayId);
          this.authenticating = false;
          this.loadpage();
        }
        else {
          this.authenticating = false;
          this.messages = [
            { severity: 'error', content: 'Invalid login', id: this.messagesCount++ }
          ];
        }
      },
      async loadpage() {
  
        if(this.isAuthenticated || this.isLoggedIn){
        
          let date = new Date();
          this.dateSelected = date.toLocaleDateString('en-us', {month: 'short', year: 'numeric'});
          this.dateSelectedString = this.dateSelected;
          this.dateSelected = new Date();
        
          let revFundDate = new Date();
        
          // check if today is last day of current month
          if(!this.isLastDay(revFundDate)){
            revFundDate.setDate(1);
            revFundDate.setHours(-1);
          }
          this.revFundDateSelected = revFundDate;
          this.revFundDateSelected = revFundDate.toLocaleDateString('en-us', {month: 'short', year: 'numeric'});
          this.revFundDateSelectedString = this.revFundDateSelected;
  
          let revFundDateNew = new Date();
        
          // check if today is last day of current month
          if(!this.isLastDay(revFundDateNew)){
            revFundDateNew.setDate(1);
            revFundDateNew.setHours(-1);
          }
          this.revFundDateSelected = revFundDateNew;
        
          let authToken = await this.getValidToken();
          if (authToken) {
            try {
              const idToken = await this.$auth.tokenManager.get('idToken');
              if (idToken?.claims?.name) {
                this.myName = idToken.claims.name;
              }
              const user = await this.$auth.getUser();
              this.workDayId = user['EID-employeeNumber'];
              this.email = user['email'];
              this.setUser(this.email);
            } catch (e) {
              // profile lookup failed but we have a valid access token — proceed
            }
          } else if (this.isLoggedIn) {
            this.workDayId = this.$store.state.workdayId;
            this.email = this.$store.state.user;
            authToken = this.$store.state.token;
          }

          if (!authToken) {
            await this.login();
            return;
          }

          this.getCompanyFunds(authToken);
          this.getCompanyPerformance(authToken);
          this.getRevolutionFund(authToken);
          this.getDailyInvestments(authToken);
          this.getFunds(authToken, this.workDayId);
  
          this.minDate = new Date('1/1/2023');
          let today = new Date();
          today.setMonth(today.getMonth() - 1);
          this.maxDate = today;
  
          this.chartData = this.setChartData();
          this.chartOptions = this.setChartOptions();
  
          this.dailyChartOptions = this.setDailyChartOptions();
        }
      },
      validateEmail() {
        if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.loginInput.username)) {
            return false;
        } else {
            return true;
        }
      },
    },
    data () {
      return {
        myName: null,
        workDayId: null,
        email: null,
        funds: [],
        companyFunds: [],
        companyPerformance: [],
        revolutionFund: [],
        numberOfFunds: 0,
        dateSelected: null,
        dateSelectedString: null,
        revFundDateSelected: null,
        revFundDateSelectedString: null,
        loading: true,
        revFundChartLoading: false,
        chartData: null,
        chartOptions: null,
        dailyChartData: null,
        dailyChartDataGain: null,
        dailyChartOptions: null,
        dailyInvestmentData: [],
        costAndFMVLabels: [],
        costData: [],
        fmvData: [],
        dailyLabels: [],
        dailyValue: [],
        dailyGain: [],
        userHasNoFunds: true,
        filterStyle: {
          background:"#dfe4ea"
        },
        fiveDayActive: false,
        oneMonthActive: false,
        sixMonthActive: false,
        yearToDateActive: false,
        oneYearActive: false,
        fiveYearActive: false,
        maxActive: true,
        totalValueActive: false,
        gainActive: true,
        minDate: null,
        maxDate:null,
        loginInput: {
          username: "",
          password: ""
        },
        isCustomAuthorized: false,
        messages: ref([]),
        messagesCount: ref(0),
        authenticating: false,
        totalPersonalValue: 0,
      }
    },
    computed: {
      ...mapGetters(["isLoggedIn"]),
      ...mapGetters(["getEmail"]),
      isAuthenticated () {
        return ((this.authState && this.authState.isAuthenticated));
      },
      totalPaidToDate () {
        return this.funds.reduce((sum, fund) => sum + (fund.paidOut || 0), 0);
      },
      projectedPayouts () {
        const totalsByYear = {};

        this.funds.forEach(fund => {
          const vestingYears = this.parseVestingYears(fund.vestingDate);
          if (vestingYears.length === 0 || !fund.leftToPay) return;

          const amountPerVestingDate = fund.leftToPay / vestingYears.length;
          vestingYears.forEach(year => {
            totalsByYear[year] = (totalsByYear[year] || 0) + amountPerVestingDate;
          });
        });

        return Object.keys(totalsByYear)
          .map(year => Number(year))
          .sort((a, b) => a - b)
          .map(year => ({ year, amount: totalsByYear[year] }));
      }
    },
    async mounted () {
      const wantsOkta = this.$route.query.loginmethod == 'okta';
      if (wantsOkta) {
        this.$router.replace({ query: {} });
      }

      if (this.$auth?.authStateManager) {
        try {
          await this.$auth.authStateManager.updateAuthState();
        } catch (e) {
          // fall through — we'll rely on the cached authState below
        }
      }
      const authState = this.$auth?.authStateManager?.getAuthState?.() || this.authState || {};

      if (!authState.isAuthenticated) {
        if (wantsOkta || this.getEmail) {
          await this.login();
          return;
        }
      } else {
        const accessToken = await this.getValidToken();
        if (!accessToken) {
          await this.login();
          return;
        }
      }

      this.loadpage();
    }
  }
  </script>
  
  <style>
  .card {
     padding: 20px;
  }

  .total-value-table {
    border-collapse: collapse;
    width: 100%;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
    border-radius: 6px;
    overflow: hidden;
  }

  .total-value-table th,
  .total-value-table td {
    border: 1px solid var(--surface-border, #dee2e6);
    padding: 8px 16px;
    text-align: center;
    white-space: nowrap;
  }

  .total-value-table thead th {
    background-color: #f5f5f5;
    font-size: 1.05rem;
  }

  .total-value-table .projected-payouts-header {
    font-weight: bold;
    background-color: #ececec;
  }

  .total-value-table tbody td {
    font-size: 1.15rem;
    padding: 12px 16px;
  }

  .total-value-table .total-value-cell {
    font-size: 1.65rem;
  }

  .total-value-mobile {
    display: none;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid var(--surface-border, #dee2e6);
  }

  .total-value-mobile-hero {
    background-color: #f5f5f5;
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid var(--surface-border, #dee2e6);
  }

  .total-value-mobile-label {
    font-weight: bold;
    font-size: 1rem;
  }

  .total-value-mobile-amount {
    font-weight: bold;
    font-size: 2rem;
  }

  .total-value-mobile-section {
    background-color: #ececec;
    font-weight: bold;
    padding: 8px 16px;
    text-align: center;
    border-bottom: 1px solid var(--surface-border, #dee2e6);
  }

  .total-value-mobile-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 1.1rem;
    border-bottom: 1px solid var(--surface-border, #dee2e6);
  }

  .total-value-mobile-row:last-child {
    border-bottom: none;
  }

  .total-value-mobile-row span:first-child {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .total-value-table {
      display: none;
    }

    .total-value-mobile {
      display: block;
    }
  }
  
  .form-group input {
      margin-bottom: 20px;
      margin-top:20px
  }
  
  .login-page {
    margin-top:30px;
     align-items: center;
     display: flex;
     text-align:left;
  }
  </style>